import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast, Toaster } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail, "Could not send reset link"));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream px-6" data-testid="forgot-password-page">
      <Toaster position="top-center" richColors />
      <div className="max-w-sm w-full">
        <img
          src="https://customer-assets-cm19k8pv.emergentagent.net/job_goa-art-space/artifacts/47po7jix_final%20logo%20no%20background%20.png"
          alt="Carpe Diem Goa"
          className="h-20 w-auto object-contain -ml-1 mb-6"
        />
        <div className="overline">Admin</div>
        <h1 className="display text-4xl mt-3">Forgot password.</h1>

        {!sent ? (
          <>
            <p className="text-muted2 text-sm mt-3">Enter the admin email and we'll send a reset link. The link is valid for 30 minutes.</p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <label className="block">
                <span className="overline">Email</span>
                <input
                  required
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  className="w-full bg-transparent border-b border-charcoal py-2 text-base focus:outline-none"
                  data-testid="forgot-email"
                />
              </label>
              <button type="submit" disabled={busy} className="btn-primary w-full justify-center" data-testid="forgot-submit">
                {busy ? "Sending…" : "Send reset link"}
              </button>
            </form>
          </>
        ) : (
          <div className="mt-6 space-y-4">
            <p className="text-sm leading-relaxed">
              If <strong>{email}</strong> matches an admin account, we've sent a reset link.
              Check your inbox (and spam folder) in the next couple of minutes.
            </p>
            <p className="text-xs text-muted2">The link expires in 30 minutes and can be used only once.</p>
          </div>
        )}

        <div className="mt-8 text-xs">
          <Link to="/admin/login" className="link-hover" data-testid="forgot-back-to-login">← Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
